export default __webpack_public_path__ + "static/media/Cloak of the Black Pharaoh.12186d1d.jpg";